import React, { useRef, useEffect } from 'react';
import { Elm } from './dijstraTutorial';

export default function ElmComponent() {
    const target = useRef();

    useEffect(() => Elm.Dijkstra_tutorial.init({ node: target.current }));

    return <div ref={target}></div>;
}
